export const trackingKeys = {
    touchPointButton: {
        basicCalendar: 'basic_calendar',
        availabilityCalendar: 'availability_calendar'
    },
    touchPointPages: {
        posting: 'posting_form'
    }
};
